import { decodePayloadFromJWT } from '../utils/jwt';

const KSTADIUM_BACKEND_URL = process.env.REACT_APP_KSTADIUM_BACKEND_URL!;
export const KSTADIUM_ACCESS_TOKEN_KEY = `kstadiumAccessToken`;
export const KSTADIUM_REFRESH_TOKEN_KEY = `kstadiumRefreshToken`;

interface PostRefreshTokenResponse {
  resultCode: 'success' | 'failed';
  data: {
    accessToken: string;
    refreshToken: string;
  };
}

export interface PostLoginResponse {
  resultCode: 'success' | 'failed';
  data: {
    accessToken: string;
    refreshToken: string;
  };
}

export interface KStadiumJWTPayload {
  info: {
    account: string;
  };
}

interface TransactionStateRes {
  resultCode: 'success' | 'failed';
  resultMessage: string;
  totalCount: number;
  data: {
    txHash: string;
    data: {
      from: string;
      to: string;
    };
    blockHash: string;
    status: string;
  };
}

const KSTADIUM = {
  getAccessToken(): string | null {
    return localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY);
  },
  getRefreshToken(): string | null {
    return localStorage.getItem(KSTADIUM_REFRESH_TOKEN_KEY);
  },
  isTokenExists(): boolean {
    return !!this.getAccessToken() && !!this.getRefreshToken();
  },
  getTokenPayload(): KStadiumJWTPayload | null {
    const accessToken = this.getAccessToken();
    return accessToken
      ? decodePayloadFromJWT<KStadiumJWTPayload>(accessToken)
      : null;
  },
  async postRefreshToken(): Promise<PostRefreshTokenResponse> {
    const res = await fetch(
      `${KSTADIUM_BACKEND_URL}/kstadium/api/comm/member/login/refresh`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': this.getAccessToken() || ``,
          'X-AUTH-REFRESH-TOKEN': this.getRefreshToken() || ``,
        },
      },
    );

    if (res.ok) {
      const result: PostRefreshTokenResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },
  async postLogin(
    userId: string,
    password: string,
  ): Promise<PostLoginResponse> {
    const res = await fetch(
      `${KSTADIUM_BACKEND_URL}/kstadium/api/comm/member/login/login`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
        },
        body: JSON.stringify({
          userId,
          password,
        }),
      },
    );

    if (res.ok) {
      const result: PostRefreshTokenResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async getTransactionState(params: string) {
    const res = await fetch(
      `${KSTADIUM_BACKEND_URL}/kstadium/api/comm/octet/transaction?txHash=${params}`,
      {
        method: `GET`,
        headers: {
          'X-AUTH-TOKEN': this.getAccessToken() || ``,
        },
      },
    );

    if (res.ok) {
      const result: TransactionStateRes = await res.json();

      return result;
    }

    return null;
  },
};

export default KSTADIUM;
